/**
 * OPS-HOTFIX-003 — canonical clinical recommendation wire types (both UI shells).
 */

export const CLINICAL_RECOMMENDATION_TYPE = Object.freeze({
  LAB: 'LAB',
  RADIOLOGY: 'RADIOLOGY',
});

/** @deprecated wire alias — maps to {@link CLINICAL_RECOMMENDATION_TYPE.RADIOLOGY} */
export const CLINICAL_RECOMMENDATION_TYPE_LEGACY_RAD = 'RAD';

/**
 * Normalize API/DB recommendation type strings for UI and filters.
 * @param {string|null|undefined} value
 * @returns {string|null|undefined}
 */
export function normalizeClinicalRecommendationType(value) {
  if (value == null || value === '') return value;
  const v = String(value).trim().toUpperCase();
  if (v === 'RAD') return CLINICAL_RECOMMENDATION_TYPE.RADIOLOGY;
  return v;
}
